export const contact = {
  title: 'Contact',
  routingNotice: 'Routing Notice',
  routingText: 'Operational inquiries should be directed to the relevant participation.',
  email: 'Email',
  address: 'Postal Address',
  phone: 'Phone',
  placeholders: {
    email: '[EMAIL]',
    address: '[ADDRESS]',
    phone: '[PHONE]'
  }
};